import { useSelector } from "react-redux";
import {
  selectActors,
  selectSelectedTake3D,
} from "../../app/slices/TrainingSlice";
import { ActorState } from "../../models/ActorState";
import ActorAvatar from "../../components/actors/ActorAvatar";
import PiCreatorDropdown from "../../components/PiCreatorDropdown/PiCreatorDropdown";
import PersonOffOutlinedIcon from "@mui/icons-material/PersonOffOutlined";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import { useTranslation } from "react-i18next";
import { isNoLookat, NO_LOOKAT } from "../../models/NoLookat";

export default function ActorStateLookatDropdown(props: {
  actorState: ActorState;
  onChange: (lookatId: string) => void;
}) {
  const { actorState, onChange } = { ...props };
  const { t } = useTranslation();
  const keepCurrentLabel = String(t("chip_select.keep_current"));
  const noActorLabel = String(t("chip_select.no_actor"));
  const actorsInSelectedTake = useSelector(selectSelectedTake3D)?.actors.filter(
    (a) => a.actorId !== actorState.actorId
  );
  const allActors = useSelector(selectActors).filter(
    (a) => a.id !== actorState.actorId
  );
  const selectedActor = allActors.find((a) => a.id === actorState.lookat);

  const keepCurrentOption = (
    <div
      key={"keep-current"}
      className={"flex gap-[10px] py-[8px]"}
      onClick={() => onChange("")}
    >
      <div className={"my-auto flex gap-[10px] h-[36px]"}>
        <RemoveOutlinedIcon className={"my-auto"} />
        <span className={"my-auto"}>{keepCurrentLabel}</span>
      </div>
    </div>
  );
  const noActorOption = (
    <div
      key={"no-actor"}
      className={"flex gap-[10px] py-[8px]"}
      onClick={() => onChange(NO_LOOKAT)}
    >
      <div className={"my-auto flex gap-[10px] h-[36px]"}>
        <PersonOffOutlinedIcon className={"my-auto"} />
        <span className={"my-auto"}>{noActorLabel}</span>
      </div>
    </div>
  );

  const items = actorsInSelectedTake
    ? actorsInSelectedTake?.map((actor) => {
        const myActor = allActors.find((a) => a.id === actor.actorId);
        return (
          <div
            key={actor.id}
            className={"flex gap-[10px] py-[8px]"}
            onClick={() => onChange(actor.actorId)}
          >
            <ActorAvatar actor={myActor} theme={"creator-selected"} />
            <div
              className={"my-auto text-[14px] text-creator-text font-medium"}
            >
              {myActor!.workingName}
            </div>
          </div>
        );
      })
    : [];

  const itemsCombined = [keepCurrentOption, noActorOption, ...items];
  const isNoActor = isNoLookat(actorState.lookat);

  const trigger = selectedActor ? (
    <div className={"flex gap-[10px] h-full w-full items-center"}>
      <ActorAvatar actor={selectedActor} theme={"creator-selected"} size="24" />
      <div className={"my-auto"}>{selectedActor!.workingName}</div>
    </div>
  ) : (
    <div
      className={"flex text-left text-[14px] text-creator-text h-full w-full"}
    >
      <div className={"my-auto flex gap-[10px]"}>
        {isNoActor ? (
          <PersonOffOutlinedIcon className={"my-auto"} />
        ) : (
          <RemoveOutlinedIcon className={"my-auto"} />
        )}
        <span className={"my-auto"}>{isNoActor ? noActorLabel : keepCurrentLabel}</span>
      </div>
    </div>
  );

  const newDropdown = (
    <PiCreatorDropdown
      label={"Lookat"}
      trigger={trigger}
      items={itemsCombined as JSX.Element[]}
    />
  );

  return <>{newDropdown}</>;
}
